import { createGlobalStyle } from "styled-components"
import styled from "styled-components"
const Style = createGlobalStyle`
  /* Override bindery UI background variable */
  :root {
    --bindery-ui-bg: transparent !important;
  }
  /* Shared styles including fonts */
  html, body {
    font-family: 'Arial';
    font-size: 13pt;
  }
  /* Regular screen styles */
  @media screen {
    body {
      margin: 0;
      padding: 0;
      background-color: #000000;
    }

    @media (max-width: 768px) {
      .📖-flipbook {
        display: none !important;
      }
      
      /* Also hide the flipbook option in the view selector dropdown */
      select.📖-select option[value="flipbook"],
      .📖-view-flip {
        display: none !important;
      }
    }
  }
    
    .📖-zoom-content {
      background-color: #000000 !important;
    }
    .📖-view-preview {
      background-color: transparent !important;
    }
    .📖-root.📖-view-flip {
      background-color: #000000 !important;
    }
    .📖-root.📖-view-print,
    .📖-root.📖-view-print.📖-show-bleed {
      background-color: #000000 !important;
    }
    /* Ensure crop marks are visible in preview */
    .📖-show-crop .📖-page::before,
    .📖-show-crop .📖-page::after {
      border-color: #ffffff !important;
      opacity: 1 !important;
    }
    /* Controls */
    .📖-controls {
      background-color: transparent !important;
      color: #ffffff !important;
      padding: 12px 16px !important;
    }
    
    /* Add just the border-color override */
    .📖-control {
      border-color: rgba(255, 255, 255, 1.0) !important;
    }
    
    .📖-controls * {
      color: #ffffff !important;
    }
    .📖-btn,
    .📖-btn-main,
    .📖-controls select {
      background-color: transparent !important;
      border: 1px solid rgba(255, 255, 255, 1.0) !important;
      color: #ffffff !important;
      padding: 4px 8px !important;
      transition: all 0.2s ease !important;
      font-size: inherit !important;
      border-radius: 6px !important;
    }
    .📖-btn:hover,
    .📖-btn-main:hover,
    .📖-controls select:hover {
      background-color: rgba(255, 255, 255, 0.1) !important;
      border-color: rgba(255, 255, 255, 0.8) !important;
    }
  }
  /* Print styles */
  @media print {
    body {
      background-color: white !important;
      margin: 0;
      padding: 0;
    }
    .📖-page {
      background-color: white !important;
      color: black !important;
    }
    /* Ensure crop marks are visible in print */
    .📖-show-crop .📖-page::before,
    .📖-show-crop .📖-page::after {
      border-color: black !important;
      opacity: 1 !important;
    }
    /* Preserve bleed area */
    .📖-show-bleed .📖-page {
      margin: var(--bindery-bleed) !important;
    }
  }
  
  /* Shared styles */
  ol {
    margin-top: 0;
    margin-bottom: 0;
    list-style-type: upper-roman;
    padding-left: 0.35in;
  }
  blockquote {
    margin-left: 0;
    margin-right: 0;
  }
  .📖-root .book-container {
    opacity: 1;
  }
  .📖-running-header {
    top: 0.3in;
    min-height: 0.3in;
    pointer-events: none;
  }
  .📖-right .📖-running-header {
    text-align: right;
    width: var(--bindery-page-width);
  }
  .📖-page.📖-left .page-header {
    padding-left: 0.35in;
  }
  .page.📖-continuation.📖-continues {
    margin-top: 0.335in;
  }
  .toc-page.page.📖-continuation.📖-continues {
    margin-top: 0;
  }
  .📖-flow-box {
    margin-bottom: var(--bindery-margin-outer);
  }
  .📖-footer {
    display: none;
  }
  .📖-footer p {
    margin-bottom: 8pt;
  }
  @page {
    size: var(--bindery-page-width) var(--bindery-page-height);
    margin: 0 !important;
    width: var(--bindery-page-width) !important;
    height: var(--bindery-page-height) !important;
  }
`
const PageBreak = styled.hr`
  display: none;
`
const Link = styled.a`
  text-decoration: none;
  color: inherit;
`
export { Style, PageBreak, Link }
